import { render } from "./role_permissions.html?vue&type=template&id=05de23f8&external"
import script from "./role_permissions.js?vue&type=script&lang=js&external"
export * from "./role_permissions.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__